"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sleep = sleep;
exports.retryWithExponentialBackoff = retryWithExponentialBackoff;
exports.retryPromise = retryPromise;
/**
 * A simple await-able sleep method. Good for delays before triggering other promises
 * @param ms
 * @returns
 */
function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
/**
 * Retry the given function with a backoff time that doubles
 * Defaults to a total delay of 3.5 seconds
 * @param promiseFn
 * @param maxAttempts
 * @param initialDelayMs
 * @returns
 * @todo Implement a maximum delay (truncated exponential backoff)
 */
function retryWithExponentialBackoff(promiseFn, maxAttempts = 4, // Total attempts - 4 means 3 retries
initialDelayMs = 500) {
    const retryFn = async (args) => {
        for (let i = 1; i <= maxAttempts; i++) {
            try {
                const result = await promiseFn(args);
                return result;
            }
            catch (err) {
                if (i === maxAttempts) {
                    throw err;
                }
                const delayTime = 2 ** (i - 1) * initialDelayMs; // How much time will it back off for
                await sleep(delayTime);
            }
        }
    };
    return retryFn;
}
/**
 * Retries a promise-returning function based on a condition specified by a callback.
 *
 * @param promiseFunction The function that returns the promise to retry.
 * @param shouldRetry A callback that takes an error as argument and returns a boolean indicating whether to retry.
 * @param maxRetries The maximum number of retries.
 * @param delayMs The delay between retries in milliseconds.
 * @returns A Promise that resolves with the result of the promiseFunction or rejects after the condition fails.
 */
function retryPromise(req) {
    const reqWithDefaults = { delayMs: 1000, maxRetries: 3, ...req };
    const { delayMs, maxRetries, promiseFunction, shouldRetry } = reqWithDefaults;
    return new Promise((resolve, reject) => {
        let attempts = 0;
        const execute = () => {
            promiseFunction()
                .then(resolve)
                .catch(error => {
                attempts++;
                if (attempts <= maxRetries && shouldRetry(error, attempts)) {
                    const delayTime = 2 ** (attempts - 1) * delayMs;
                    setTimeout(execute, delayTime);
                }
                else {
                    reject(error);
                }
            });
        };
        execute();
    });
}
